import axios from "axios";
import { url, online } from "./contant";
// Create an Axios instance
const api = axios.create({
  // baseURL: `${online}/api/v1`,
  baseURL: `${url}/api/v1`, // your backend
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
